export default __webpack_public_path__ + "static/media/img (1).79883ab1.jpg";